/**
 * TrackTECH lazy nav:
 * 1) Mobile drawer — SSR is the real tree (data-loaded=1). Do not replace
 *    innerHTML on open. Fetch tt-lazy-drawer-nav only as a fallback.
 * 2) Part Finder mega — brand panels from JSON (first brand SSR'd)
 * 3) Burger Shop Parts — SSR from Navigation (# type headers + models)
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* ---------- Mobile drawer fallback (legacy stub only) ---------- */
  function initLazyDrawer() {
    var details = document.querySelector('menu-drawer.header-menu-drawer > details');
    var mount = document.getElementById('Header-Drawer-Lazy-Mount');
    if (!details || !mount) return;
    if (mount.dataset.loaded === '1' && mount.querySelector('.main-drawer-nav')) {
      return;
    }

    var sectionId = mount.getAttribute('data-section') || 'tt-lazy-drawer-nav';
    var loading = false;

    function loadDrawer() {
      if (mount.dataset.loaded === '1' || loading) return Promise.resolve();
      if (mount.querySelector('.main-drawer-nav') && !mount.querySelector('.header-drawer-ssr-nav')) {
        mount.dataset.loaded = '1';
        return Promise.resolve();
      }
      loading = true;
      mount.setAttribute('aria-busy', 'true');
      var url =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/') +
        '?section_id=' +
        encodeURIComponent(sectionId);

      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('drawer section ' + r.status);
          return r.text();
        })
        .then(function (html) {
          if (mount.dataset.loaded === '1') return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var root =
            doc.querySelector('[data-tt-lazy-drawer-body]') ||
            doc.querySelector('.tt-lazy-drawer-nav-root') ||
            doc.querySelector('.main-drawer-nav');
          if (!root) throw new Error('drawer body missing');
          var next = document.createElement('div');
          if (root.hasAttribute('data-tt-lazy-drawer-body') || root.classList.contains('tt-lazy-drawer-nav-root')) {
            next.innerHTML = root.innerHTML;
          } else {
            next.appendChild(doc.importNode(root, true));
            var util = doc.querySelector('.menu-drawer-utility');
            if (util) next.appendChild(doc.importNode(util, true));
          }
          mount.replaceChildren.apply(mount, Array.prototype.slice.call(next.childNodes));
          mount.dataset.loaded = '1';
          mount.setAttribute('aria-busy', 'false');
          initDrawerCatalog();
          if (window.webvista && typeof window.webvista.initLazyImages === 'function') {
            window.webvista.initLazyImages();
          }
        })
        .catch(function () {
          if (mount.querySelector('.main-drawer-nav')) {
            mount.setAttribute('aria-busy', 'false');
            return;
          }
          mount.innerHTML =
            '<p class="header-drawer-lazy-error" style="padding:1rem">Menu unavailable. <a href="/">Refresh</a></p>';
          mount.setAttribute('aria-busy', 'false');
        })
        .finally(function () {
          loading = false;
        });
    }

    if (window.requestIdleCallback) {
      window.requestIdleCallback(function () {
        loadDrawer();
      }, { timeout: 2500 });
    } else {
      setTimeout(loadDrawer, 400);
    }
    details.addEventListener('pointerdown', function () {
      loadDrawer();
    }, { once: true });
    details.addEventListener('toggle', function () {
      if (details.open) loadDrawer();
    });
  }

  /* ---------- Part Finder brand panels ---------- */
  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildPanelHtml(menuHandle, slug, brand) {
    var html = '';
    html +=
      '<div class="ttmm-panel-eyebrow">' + escapeHtml(brand.name).toUpperCase() + '</div>';
    (brand.groups || []).forEach(function (group, gi) {
      var typeId = 'ttmm-type-' + menuHandle + '-' + slug + '-' + (gi + 1);
      html += '<section class="ttmm-machine-group" aria-labelledby="' + typeId + '">';
      html +=
        '<div id="' +
        typeId +
        '" class="ttmm-machine-type">' +
        escapeHtml(group.type).toUpperCase() +
        '</div>';
      html += '<div class="ttmm-models-grid">';
      (group.models || []).forEach(function (m) {
        html +=
          '<a class="ttmm-model" href="' +
          escapeHtml(m.href) +
          '">' +
          escapeHtml(m.text) +
          '</a>';
      });
      html += '</div></section>';
    });
    html +=
      '<a class="ttmm-view-all" href="' +
      escapeHtml(brand.collectionHref) +
      '">All ' +
      escapeHtml(brand.name) +
      ' tracks →</a>';
    return html;
  }

  function buildDrawerBrandHtml(brand) {
    var html = '';
    (brand.groups || []).forEach(function (group) {
      html += '<div class="ttmm-drawer-type">' + escapeHtml(group.type).toUpperCase() + '</div>';
      html += '<div class="ttmm-drawer-models">';
      (group.models || []).forEach(function (m) {
        html +=
          '<a class="ttmm-drawer-model" href="' +
          escapeHtml(m.href) +
          '">' +
          escapeHtml(m.text) +
          '</a>';
      });
      html += '</div>';
    });
    html +=
      '<a class="ttmm-drawer-all" href="' +
      escapeHtml(brand.collectionHref) +
      '">All ' +
      escapeHtml(brand.name) +
      ' tracks →</a>';
    return html;
  }

  function parseTtmmData(root) {
    var dataEl = root.querySelector('script[type="application/json"][data-ttmm-brands]');
    if (!dataEl) return null;
    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function ensurePanel(menu, slug, data) {
    var brand = data.brands[slug];
    if (!brand) return null;
    var panel = menu.querySelector('.ttmm-panel[data-panel="' + slug + '"]');
    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'ttmm-panel-' + (data.menuHandle || 'menu') + '-' + slug;
      panel.className = 'ttmm-panel';
      panel.dataset.panel = slug;
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-label', brand.name + ' models');
      panel.hidden = true;
      var host = menu.querySelector('.ttmm-models');
      if (!host) return null;
      host.appendChild(panel);
    }
    if (panel.getAttribute('data-ttmm-filled') !== '1') {
      panel.innerHTML = buildPanelHtml(data.menuHandle || 'menu', slug, brand);
      panel.setAttribute('data-ttmm-filled', '1');
    }
    return panel;
  }

  function fillDrawerBrand(root, slug, data) {
    var brand = data.brands && data.brands[slug];
    if (!brand) return;
    var panel = root.querySelector('[data-ttmm-drawer-panel="' + slug + '"]');
    if (!panel || panel.getAttribute('data-ttmm-filled') === '1') return;
    panel.innerHTML = buildDrawerBrandHtml(brand);
    panel.setAttribute('data-ttmm-filled', '1');
  }

  function initDrawerCatalog() {
    document.querySelectorAll('.ttmm-catalog-drawer[data-ttmm-lazy]').forEach(function (root) {
      if (root.dataset.ttmmInited === '1') return;
      var data = parseTtmmData(root) || parseTtmmData(root.parentElement || document);
      if (!data || !data.brands) return;
      root.dataset.ttmmInited = '1';
      initTtmmMore(root);

      root.querySelectorAll('details.ttmm-drawer-brand').forEach(function (det) {
        var slug = det.getAttribute('data-brand');
        if (!slug) return;
        var fill = function () {
          fillDrawerBrand(root, slug, data);
        };
        det.addEventListener('pointerdown', fill);
        det.addEventListener('toggle', function () {
          if (det.open) fill();
        });
      });
    });
  }

  function initTtmmMore(root) {
    if (!root) return;
    root.querySelectorAll('[data-ttmm-more]').forEach(function (btn) {
      if (btn.dataset.ttmmMoreInited === '1') return;
      btn.dataset.ttmmMoreInited = '1';
      var list = btn.closest('[data-ttmm-brand-list]');
      if (!list) return;
      btn.addEventListener('click', function () {
        var on = list.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        btn.textContent = on ? 'Less' : '+ More';
      });
    });
  }

  function initTtmmMenus() {
    document.querySelectorAll('.ttmm-mega[data-ttmm-lazy]').forEach(function (menu) {
      if (menu.dataset.ttmmInited === '1') return;
      menu.dataset.ttmmInited = '1';
      initTtmmMore(menu);

      var data = parseTtmmData(menu);
      if (!data) return;

      var buttons = menu.querySelectorAll('.ttmm-brand-btn');
      var items = menu.querySelectorAll('.ttmm-brand-item');

      function activate(slug) {
        ensurePanel(menu, slug, data);
        for (var i = 0; i < items.length; i++) {
          var btn = items[i].querySelector('.ttmm-brand-btn');
          var on = btn && btn.dataset.brand === slug;
          items[i].classList.toggle('is-active', !!on);
          if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        }
        var panels = menu.querySelectorAll('.ttmm-panel');
        for (var j = 0; j < panels.length; j++) {
          var panelOn = panels[j].dataset.panel === slug;
          panels[j].classList.toggle('is-active', panelOn);
          panels[j].hidden = !panelOn;
        }
      }

      var coarse = window.matchMedia && window.matchMedia('(hover: none)').matches;
      for (var i = 0; i < buttons.length; i++) {
        (function (btn) {
          btn.addEventListener('mouseenter', function () {
            activate(btn.dataset.brand);
          });
          btn.addEventListener('focus', function () {
            activate(btn.dataset.brand);
          });
          if (coarse) {
            btn.addEventListener('click', function (e) {
              var already = btn.getAttribute('aria-expanded') === 'true';
              if (!already) {
                e.preventDefault();
                activate(btn.dataset.brand);
              }
            });
          }
        })(buttons[i]);
      }
    });
  }

  ready(function () {
    initLazyDrawer();
    initTtmmMenus();
    initDrawerCatalog();
  });
})();
